import type { StorageAddonId } from './storagePlans';
export const STORAGE_MANAGEMENT_CONSENT_VERSION = 'storage-renewal-2026-10-25';
export type StorageManagementState = { enabled: false } | {
  enabled: true;
  current: { offerId: StorageAddonId; paidUntil: number } | null;
  currentRefunded: boolean;
  nextOfferId: StorageAddonId | null;
  nextAmount: number | null;
  effectiveAt: number | null;
  revision: string;
  canManage: boolean;
  proEnds: boolean;
  pending: { id: string; desiredOfferId: StorageAddonId | null } | null;
};
